import type { Bridge, HostInfo } from '@casa/bridge';
import { capabilityProfile, loadDriverCatalog, type CapabilityProfile, type DriverCatalog, type WorkerLike } from '@casa/driver-host';
import { BUILT_IN_MANIFESTS } from '@casa/drivers/manifests';

// The app's drivers: the Worker each runs in, the capability profile of this build, and the
// catalog of built-in and installed drivers that connections are resolved against.

/** A driver Worker from /sandbox/ (see driver_worker.ts). */
export function createDriverWorker(name: string) : WorkerLike {
    return new Worker(new URL('./driver_worker.ts', import.meta.url), { type: 'module', name }) as unknown as WorkerLike;
}

/** `VITE_CASA_USER_DRIVERS=on|off` at build time; without it, installed drivers run everywhere but on iOS. */
export function buildProfile() : CapabilityProfile {
    const shell = (globalThis as { casaHost?: HostInfo }).casaHost?.shell;
    const userDrivers: unknown = import.meta.env.VITE_CASA_USER_DRIVERS;

    return capabilityProfile(shell, typeof userDrivers === 'string' ? userDrivers : undefined);
}

export const BUILT_IN_IDS: ReadonlySet<string> = new Set(Object.keys(BUILT_IN_MANIFESTS));

export function loadDrivers(bridge: Bridge) : Promise<DriverCatalog> {
    return loadDriverCatalog(bridge.storage, BUILT_IN_MANIFESTS, buildProfile());
}
